import { Outlet } from 'react-router-dom';

/**
 * Root layout that wraps all routes.
 */
export const RootLayout: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
